module.exports = __webpack_public_path__ + "static/media/03.443b6ec5.mp3";